import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { businessAuthGuard } from './guards/business-auth.guard';
import { businessCompanyAdminGuard } from './guards/business-company-admin.guard';
import { businessGuestGuard } from './guards/business-guest.guard';

const routes: Routes = [
  {
    path: 'viaje/:id',
    loadComponent: () => import('./viaje/viaje.page').then(m => m.ViajePage)
  },
  {
    path: 'viaje-flex/:tripLegId',
    loadComponent: () => import('./viaje-flex/viaje-flex.page').then(m => m.ViajeFlexPage),
  },
  {
    path: 'envios/:id',
    loadComponent: () => import('./envios/envios.page').then(m => m.EnviosPage)
  },
  {
    path: 'sos/:id',
    loadComponent: () => import('./sos/sos.page').then(m => m.SosPage)
  },
  {
    path: 'encuesta-servicio/:nanoId',
    loadComponent: () =>
      import('./encuesta-servicio/encuesta-servicio.page').then((m) => m.EncuestaServicioPage),
  },
  {
    path: 'empresas/iniciar-sesion',
    canActivate: [businessGuestGuard],
    loadComponent: () => import('./business/business-login/business-login.page').then(m => m.BusinessLoginPage)
  },
  {
    path: 'empresas/solicitar-recuperacion',
    canActivate: [businessGuestGuard],
    loadComponent: () => import('./business/business-forgot-password/business-forgot-password.page').then(m => m.BusinessForgotPasswordPage)
  },
  {
    path: 'empresas/recuperar-contrasena',
    canActivate: [businessGuestGuard],
    loadComponent: () => import('./business/business-reset-password/business-reset-password.page').then(m => m.BusinessResetPasswordPage)
  },
  {
    path: 'empresas',
    canActivate: [businessAuthGuard],
    loadComponent: () => import('./business/business-dashboard-full.page').then(m => m.BusinessDashboardFullPage),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'panel' },
      { path: 'panel', loadComponent: () => import('./business/business-dashboard-home.page').then(m => m.BusinessDashboardHomePage) },
      { path: 'cuenta', loadComponent: () => import('./business/business-account/business-account.page').then(m => m.BusinessAccountPage), data: { title: 'Mi cuenta' } },
      { path: 'viajes', loadComponent: () => import('./business/business-trips/business-trips.page').then(m => m.BusinessTripsPage), data: { title: 'Viajes de la empresa' } },
      {
        path: 'viajes-flex',
        loadComponent: () =>
          import('./business/business-trips-flex/business-trips-flex.page').then(
            (m) => m.BusinessTripsFlexPage,
          ),
        data: { title: 'Viajes flex' },
      },
      {
        path: 'viajes-flex/nuevo',
        loadComponent: () =>
          import('./business/business-trips-flex-new/business-trips-flex-new.page').then(
            (m) => m.BusinessTripsFlexNewPage,
          ),
        data: { title: 'Nuevo viaje flex' },
      },
      {
        path: 'viajes-flex/:linkId',
        loadComponent: () =>
          import('./business/business-trips-flex/business-trips-flex-detail.page').then(
            (m) => m.BusinessTripsFlexDetailPage,
          ),
        data: { title: 'Detalle viaje flex' },
      },
      {
        path: 'viajes-recurrentes',
        loadComponent: () =>
          import('./business/business-recurring-trips/business-recurring-trips.page').then(
            (m) => m.BusinessRecurringTripsPage,
          ),
        data: { title: 'Viajes recurrentes' },
      },
      {
        path: 'viajes-recurrentes/nuevo',
        loadComponent: () =>
          import('./business/business-recurring-trips-new/business-recurring-trips-new.page').then(
            (m) => m.BusinessRecurringTripsNewPage,
          ),
        data: { title: 'Nuevo viaje recurrente' },
      },
      {
        path: 'viajes-recurrentes/:seriesId',
        loadComponent: () =>
          import('./business/business-recurring-trips-detail/business-recurring-trips-detail.page').then(
            (m) => m.BusinessRecurringTripsDetailPage,
          ),
        data: { title: 'Detalle serie recurrente' },
      },
      { path: 'viajes-unificado', pathMatch: 'full', redirectTo: 'viajes-unificado/normal' },
      { path: 'viajes-unificado/nuevo', pathMatch: 'full', redirectTo: 'viajes-unificado/nuevo/normal' },
      {
        path: 'viajes-unificado/nuevo/:tipo',
        loadComponent: () =>
          import('./business/business-unified-trips/business-unified-trips-new.page').then(
            (m) => m.BusinessUnifiedTripsNewPage,
          ),
        data: { title: 'Nuevo viaje' },
      },
      {
        path: 'viajes-unificado/:tipo',
        loadComponent: () =>
          import('./business/business-unified-trips/business-unified-trips.page').then(
            (m) => m.BusinessUnifiedTripsPage,
          ),
        data: { title: 'Viajes' },
      },
      { path: 'viajes/nuevo', loadComponent: () => import('./business/business-trips-new/business-trips-new.page').then(m => m.BusinessTripsNewPage), data: { title: 'Nuevo viaje' } },
      {
        path: 'viajes/pendientes',
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () => import('./business/business-trips-pending/business-trips-pending.page').then(m => m.BusinessTripsPendingPage),
        data: { title: 'Viajes pendientes de cobro' },
      },
      {
        path: 'viajes/:tripId',
        loadComponent: () =>
          import('./business/business-trip-detail/business-trip-detail.page').then(
            (m) => m.BusinessTripDetailPage,
          ),
        data: { title: 'Detalle de viaje' },
      },
      { path: 'corte-pendiente', 
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () => import('./business/business-pending-payment/business-pending-payment.page').then(m => m.BusinessPendingPaymentPage), 
        data: { title: 'Corte a pagar' } 
      },
      { path: 'liquidaciones', 
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () => import('./business/business-settlements/business-settlements.page').then(m => m.BusinessSettlementsPage), 
        data: { title: 'Liquidaciones / pagos realizados' } 
      },
      { path: 'liquidaciones/:id/viajes', 
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () => import('./business/business-settlement-trips/business-settlement-trips.page').then(m => m.BusinessSettlementTripsPage), 
        data: { title: 'Viajes de la liquidación' }
      },
      { path: 'folios',
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () => import('./business/business-folios/business-folios.page').then(m => m.BusinessFoliosPage), 
        data: { title: 'Folios' } 
      },
      { path: 'resumen', 
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () => import('./business/business-summary/business-summary.page').then(m => m.BusinessSummaryPage), 
        data: { title: 'Resumen contable' } 
      },
      { path: 'usuarios', 
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () => import('./business/business-users/business-users.page').then(m => m.BusinessUsersPage), 
        data: { title: 'Usuarios de la empresa' } 
      },
      { path: 'usuarios/crear', 
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () => import('./business/business-users-create/business-users-create.page').then(m => m.BusinessUsersCreatePage), 
        data: { title: 'Crear usuario' } 
      },
      { path: 'usuarios/editar/:id', 
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () => import('./business/business-users-edit/business-users-edit.page').then(m => m.BusinessUsersEditPage), 
        data: { title: 'Editar usuario' } 
      },
      {
        path: 'centros-de-costo/crear',
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () =>
          import('./business/business-cost-centers-create/business-cost-centers-create.page').then(
            (m) => m.BusinessCostCentersCreatePage
          ),
        data: { title: 'Agregar centro de costo' },
      },
      {
        path: 'centros-de-costo/editar/:id',
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () =>
          import('./business/business-cost-centers-edit/business-cost-centers-edit.page').then(
            (m) => m.BusinessCostCentersEditPage
          ),
        data: { title: 'Editar centro de costo' },
      },
      {
        path: 'centros-de-costo',
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () =>
          import('./business/business-cost-centers/business-cost-centers.page').then(
            (m) => m.BusinessCostCentersPage
          ),
        data: { title: 'Centros de costo' },
      },
      {
        path: 'direcciones-preferidas/crear',
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () =>
          import('./business/business-addresses-create/business-addresses-create.page').then(
            (m) => m.BusinessAddressesCreatePage
          ),
        data: { title: 'Agregar dirección preferida' },
      },
      {
        path: 'direcciones-preferidas/editar/:id',
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () =>
          import('./business/business-addresses-edit/business-addresses-edit.page').then(
            (m) => m.BusinessAddressesEditPage
          ),
        data: { title: 'Editar dirección preferida' },
      },
      {
        path: 'direcciones-preferidas',
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () =>
          import('./business/business-addresses/business-addresses.page').then(
            (m) => m.BusinessAddressesPage
          ),
        data: { title: 'Direcciones preferidas' },
      },
      { path: 'pasajeros', 
        canActivate: [businessCompanyAdminGuard],
        loadComponent: () => import('./business/business-passengers/business-passengers.page').then(m => m.BusinessPassengersPage), 
        data: { title: 'Pasajeros vinculados' } 
      },
      { path: 'pasajeros/agregar', 
        canActivate: [businessCompanyAdminGuard], 
        loadComponent: () => import('./business/business-passengers-add/business-passengers-add.page').then(m => m.BusinessPassengersAddPage), 
        data: { title: 'Vincular usuario a la empresa' } 
      },
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./not-found/not-found.page').then(m => m.NotFoundPage)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
